import React, { useState, useEffect, useRef } from 'react';
import styles from '../styles/interactive-docs.module.css';
import { SearchIcon } from '../../../components/Icon';

const DocsSearchModal = ({
    isOpen,
    onClose,
    categories = [],
    onSelectResult,
    enabledModules = {}
}) => {
    const [query, setQuery] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            setQuery('');
            setTimeout(() => inputRef.current?.focus(), 50);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    // Сбор всех видимых статей
    const allItems = [];
    categories.forEach((cat) => {
        (cat.items || []).forEach((item) => {
            if (!item.requiredModule || enabledModules[item.requiredModule]) {
                allItems.push({
                    ...item,
                    categoryTitle: cat.title
                });
            }
        });
    });

    const filtered = query.trim() === ''
        ? allItems.slice(0, 8)
        : allItems.filter((item) => {
            const q = query.toLowerCase();
            const titleMatch = item.title.toLowerCase().includes(q);
            const summaryMatch = item.summary && item.summary.toLowerCase().includes(q);
            const catMatch = item.categoryTitle.toLowerCase().includes(q);
            return titleMatch || summaryMatch || catMatch;
        });

    return (
        <div className={styles.searchBackdrop} onClick={onClose}>
            <div className={styles.searchModal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.searchInputWrapper}>
                    <SearchIcon size={18} />
                    <input
                        ref={inputRef}
                        type="text"
                        className={styles.searchInput}
                        placeholder="Поиск по статьям, инструментам и функциям..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <span className={styles.searchKbd}>ESC</span>
                </div>

                <div className={styles.searchResultsList}>
                    {filtered.length === 0 ? (
                        <div className={styles.searchEmpty}>
                            По запросу «{query}» ничего не найдено.
                        </div>
                    ) : (
                        filtered.map((item) => {
                            const IconComponent = item.icon;
                            return (
                                <div
                                    key={item.id}
                                    className={styles.searchResultItem}
                                    onClick={() => {
                                        onSelectResult(item.id);
                                        onClose();
                                    }}
                                >
                                    <div className={styles.searchResultTitle}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            {IconComponent && <IconComponent size={14} />}
                                            <span>{item.title}</span>
                                        </div>
                                        <span className={styles.searchResultCategory}>{item.categoryTitle}</span>
                                    </div>
                                    {item.summary && (
                                        <div className={styles.searchResultSnippet}>{item.summary}</div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
};

export default DocsSearchModal;
